module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-two-sub-one.1493261b.jpg";